
import React from 'react';
import './DailyScore.css'
import { Card, Icons } from '../../SharedComponents';
import { EntryScores } from '../../../../Services/DataService/Model/DailyEntry';
import { GLStep } from '../../../../ViewModel/TutorialStateViewModel';
import { TutorialFlyout } from '../../SharedComponents/TutorialFlyout';




export function DailyScore({ withElevation, onScoreChange, score, tutorialSteps, className }: {
    withElevation?: boolean,
    score: EntryScores,
    onScoreChange: (score: number) => void,
    tutorialSteps?: GLStep[],
    className?: string
}) {

    const [activeIndex, setActiveIndex] = React.useState(score);
    const renderCircle = (index: number, text?: string) => {
        return (
            <div className='gl-daily-score-option flex flex-column justify-content-start align-items-center'
                onClick={() => {
                    setActiveIndex(index);
                    onScoreChange(index);
                }}
            >
                <div className={`gl-dailyscore-circle gl-dailyscore-circle${index}${activeIndex === index ? ' gl-active' : ''}`}></div>
                {text && <>
                    <div className='gl-dailyscore-line'></div>
                    <p className='gl-dailyscore-label gl-dailyscore-label-typography'>{text}</p>
                </>}
            </div>
        );
    }

    return (
        <div className={`gl-daily-score flex flex-column mb-4 ${className ?? ''}`}>
            <Card noMargin disableClick>
                <TutorialFlyout steps={tutorialSteps}>
                    <div className='flex flex-row justify-content-start align-items-center mb-3'>
                        <Icons.CardBulletIcon />
                        <h3 className='gl-content-header-typography gl-daily-score-header'>How did your day feel?</h3>
                    </div>
                </TutorialFlyout>
                <div className={withElevation ? ' gl-with-elevation' : ''}>
                    <div className='relative flex flex-column align-items-center'>
                        <div className='gl-daily-score-track'></div>
                        <div className='gl-daily-score-circles flex flex-row justify-content-between w-full'>
                            {renderCircle(1, 'Terrible')}
                            {renderCircle(2,)}
                            {renderCircle(3, 'Average')}
                            {renderCircle(4,)}
                            {renderCircle(5, 'Amazing')}
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    );
}